import React, { useState, useCallback, useContext, useEffect } from "react";
import style from "./Profile.module.css";
import { motion, AnimatePresence } from "framer-motion";
import closeIcon from "../assets/icons/close.svg";
import ColourPicker from "../components/colourPicker/ColourPicker";
import UserContext from "../contexts/UserContext";
import { setDataInLocalStorage } from "../utils/storage";
import ProfilePic from "../components/profilePic/ProfilePic";
import PhotoPicker from "../components/photoPicker/PhotoPicker";

type ProfileProps = {
  show: boolean;
  closePressed: () => void;
};

const Profile = ({ show, closePressed }: ProfileProps) => {
  // User Data
  const { state: userState, dispatch: dispatchUser } = useContext(UserContext);
  // TODO: Create Name input component for use here and in Onboarding.
  const [name, setName] = useState(userState.name);

  useEffect(() => {
    setName(userState.name);
  }, [userState]);

  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setName(value);
    },
    []
  );

  const handleNameBlur = () => {
    dispatchUser({ type: "SET_FIRST_NAME", name: name });
    const updatedData = { ...userState, name: name };
    setDataInLocalStorage("user", updatedData);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="profile"
          className={style.container}
          animate={{ y: "0%" }}
          initial={{ y: "100%" }}
          exit={{ y: "100%" }}
          transition={{ ease: "easeInOut" }}
        >
          <img
            src={closeIcon}
            alt="Close"
            role="button"
            onClick={closePressed}
          />
          <section>
            <PhotoPicker size={112} />
            <input
              type="text"
              placeholder="First name"
              value={name}
              onChange={handleNameChange}
              onBlur={handleNameBlur}
            />
          </section>

          <ColourPicker />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Profile;
